module.exports = __webpack_public_path__ + "static/img/42-20284540.feb223f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/our-customers/42-20284540.jpg
// module id = 0TyK
// module chunks = 0